<template>
    <div>
        <p class="headline">
            <v-icon style="margin-top:-5px;">person</v-icon>User
            <small>your profile</small>
        </p>

        <v-breadcrumbs :items="items">
            <template v-slot:item="props">
                <v-icon v-if="props.item.icon" style="color:#fff;">{{props.item.icon}}</v-icon>
                <v-breadcrumbs-item
                @click.prevent="props.item.href"
                :class="[props.item.disabled && 'disabled']"
                >{{ props.item.text.toUpperCase() }}</v-breadcrumbs-item>
            </template>
        </v-breadcrumbs>

        <v-row>
            <v-col cols="12" md="4">
                <v-card tile>
                    <v-card-title>Your profile</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                    <v-form ref="profileEditForm">
                        <v-col>
                            <v-text-field 
                            type="text" 
                            label="Full Name"
                            hide-details
                            v-model="user.name"></v-text-field>
                        </v-col>
        
                        <v-col>
                            <v-text-field 
                            type="text" 
                            label="Email Address" 
                            hide-details
                            v-model="user.email">
                            </v-text-field>
                        </v-col>

                        <v-col>
                            <v-text-field 
                            type="text" 
                            label="Company" 
                            hide-details
                            v-model="user.company_name">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-autocomplete
                            v-model="user.timezone"
                            label="Select Timezone"
                            :items="timezons"
                            item-value="id"
                            hide-details
                            item-text="dname"></v-autocomplete>
                        </v-col>
                    </v-form>
                    </v-card-text>
                    <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" tile @click.prevent="updateProfile">Update Profile</v-btn>
                    </v-card-actions>
                </v-card>

                <v-card tile class="mt-4">
                    <v-card-title>Change Password</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                    <v-form ref="passwordEditForm">

                            <v-col>
                                <v-text-field 
                                type="password" 
                                label="New password" 
                                v-model="newPassword"
                                :rules="passwordRules"
                                hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field 
                                type="password" 
                                label="Retype new password" 
                                v-model="confirmNewPassword"
                                :rules="passwordRules"
                                hide-details
                                ></v-text-field>
                            </v-col>

                    </v-form>
                    </v-card-text>
                    <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" tile @click.prevent="updatePassword">Update Password</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="12" md="4">
                
            </v-col>
        </v-row>
    </div>
</template>
<script>
import axios from './axios'
import s3photo from 'axios'
import moment from 'moment-timezone'
import momentm from 'moment'
import timezons from '../../../timezons'
export default {
    data(){
        return {
            items: [
                {
                text: "Profile",
                disabled: true,
                href: this.profile,
                icon: 'person'
                }
            ],
            user:[],
            timezons:timezons,
            selectedTimezone:null,
            currentPassword:null,
            newPassword:null,
            confirmNewPassword:null,
            passwordRules: [
            v => !!v || 'This field is required',
            ],
        }
    },
    methods:{
        profile(){
            this.$router.push('/admin/profile')
        },
        updateProfile(){
           
            let company = this.user.company_name
            let timezone = this.timezons.filter(tz=>{
                return tz.id==this.user.timezone
            })

            let data = {
                name: this.user.name,
                company_name: this.user.company_name,
                email: this.user.email,
                timezone: timezone[0].name,
                dst: timezone[0].dst
            }

            axios.put('profile/'+this.user.id+'?token='+this.$store.getters.getToken, data)
                .then(response=>{
                   this.$store.dispatch('setAlert', response.data.message)
                   localStorage.setItem('timezone', timezone[0].name)
                   localStorage.setItem('dst', timezone[0].dst)
                   localStorage.setItem('company', company)
                   this.$store.dispatch('setUserTimezone', timezone[0].name)
                   
                })
                .catch(error=>{
                    this.$store.dispatch('setErrorAlert', error.response.data.message)
                })
        },
        updatePassword(){
            if(!this.$refs.passwordEditForm.validate()) return
            let formData = {
                'currentPassword':this.currentPassword,
                'newPassword':this.newPassword,
                'confirmNewPassword':this.confirmNewPassword
            }
            axios.post('password-update/'+this.user.id, formData,{
                params:{
                    token: this.$store.getters.getToken,
                    user_id: this.$store.getters.getUser
                }
            })
            .then(response=>{
                this.$store.dispatch('setAlert', response.data.message)
            })
            .catch(error=>{
                if(!error.response.data.message){
                    error.response.data.message = 'Invalid Input'
                }
                this.$store.dispatch('setErrorAlert', error.response.data.message)
            })
        }
    },
    created(){
        console.log(momentm.tz.names())
        axios.get('/profile',
        {
            params:{
                token: this.$store.getters.getToken,
                user_id: this.$store.getters.getUser
            }
        })
        .then(response=>{
            this.user = response.data.user
             let timezone = this.timezons.filter(tz=>{
                return tz.name == localStorage.getItem('timezone') && tz.dst==localStorage.getItem('dst')
            })
            this.user.timezone = timezone[0].id
        })

        localStorage.setItem('previousUrl', localStorage.getItem('currentUrl'))
        localStorage.setItem('currentUrl', '/admin/profile');
    }
}
</script>
<style scoped>
.v-breadcrumbs {
  background-color: #0f4e74;
  padding: 6px 8px;
  color: #fff; 
}
.v-breadcrumbs__item {
  color: #fff;
}
</style>